export default "__VITE_ASSET__72cc59be__"